
import { HeartBeat, IADPState } from "../types";
import RequestService from "../util/request";
import {environment} from "../util";
import { AppStateProvider } from "../state/Provider";
let intervalId: any = undefined;
let numberOfHeartbeatPending = 0;
const HeartbeatService = {
    post:async ( isAsync: boolean, cb?:any)=>{
        const provider = AppStateProvider.getInstance();
      const state = provider.getState();
       if(!state.sessionState.schoolDetails?.setupCode) return;
        const payload : HeartBeat = {
            clientLaunchId: state.appState.appLaunchId as string,
            setupCode: state.sessionState.schoolDetails?.setupCode?.toUpperCase() as string,
            deviceId: state.deviceState.deviceId as string,
            loginId: "NA"
        }
        if(!isAsync){
            payload.assessmentLocation = state.sessionState.selectedAssessmentLocation;
        }
        
        const url = state.sessionState.selectedAssessmentMode === "ncs" ? state.connectedNCSState?.config.adsServices.heartbeatUrl: 
        `${environment.resolveApiDomain()}/${isAsync ? state.appState.configuration?.onlineServices.heartbeatAsync : state.appState.configuration?.onlineServices.heartbeat}`
        RequestService.postHeartbeat(payload,url as string,cb);   
    },
init: (state: IADPState,async: boolean, cb?:any, interval?: number)=>{
    numberOfHeartbeatPending++;
    const callback = () => {
        numberOfHeartbeatPending--;
     } 
    HeartbeatService.post(true,callback);
    if (typeof intervalId=== 'number') {
        console.log(`[Heartbeat Service][Clearing interval] ${intervalId}`);
        clearInterval(intervalId);
      }
      intervalId = setInterval(()=>{
        if(numberOfHeartbeatPending > 0) return;
         const callback = (response:any) => {
            if(response.status === 200 && response.data.action !=="") {
                cb(response.data.action);
            }
            numberOfHeartbeatPending--;
         }
         numberOfHeartbeatPending++;   
         HeartbeatService.post(async,callback);
      },interval ? interval : (state.appState.configuration?.heartbeatIntervalSec || 10 )*1000)
},
cancelHeartbeat: ()=>{
    if (typeof intervalId=== 'number') {
        console.log(`[Heartbeat Service][Canceling Heartbeat] ${intervalId}`);
        clearInterval(intervalId);
      }
}
}
export default HeartbeatService;